export const formatMoney = (centsValue: number, currency = "EUR", locale = "de-DE") => new Intl.NumberFormat(locale, { style: "currency", currency }).format(centsValue / 100);
